import { Component } from 'react';
import DayQualityElement from './DayQualityElement';
import '@app/components/sqdp/all_factory/styles/quality-layout.css';
import dayjs from 'dayjs';

class QualityLayout extends Component {
  state = {
    showInfo: false,
    element: {},
  };

  showInfo = (num) => {
    this.props.showIssueInfo(num, 2);
  };

  getColorOfDayInt = (issueOfDay, dateNum) => {
    if (!issueOfDay) return 'emtpy_state';

    const {
      isRestDay,
      countQualityTotal = 0,
      highestQualityProductionDownTimeMinutes = 0,
      highestQualityErrorProductNumber = 0,
    } = issueOfDay;

    const thisDay = dayjs().date(dateNum).day();

    // Ngày nghỉ cuối tuần
    if (isRestDay && (thisDay === 6 || thisDay === 0)) {
      return 'emtpy_state';
    }

    let today = dayjs();
    let selectedTime = dayjs(this.props.selectedMonth);
    if (
      today.get('month') <= selectedTime.get('month') &&
      today.get('year') <= selectedTime.get('year') &&
      dateNum > today.get('date')
    ) {
      return 'emtpy_state';
    }

    // 🔴 Có thời gian dừng sản xuất > 30 hoặc lỗi chất lượng cao > 3
    if (highestQualityProductionDownTimeMinutes > 30 || highestQualityErrorProductNumber > 3) {
      return 'red_state';
    }
    //🟢 Không dừng sản xuất và không lỗi chất lượng cao
    if (highestQualityProductionDownTimeMinutes === 0 && highestQualityErrorProductNumber === 0) {
      return 'green_state';
    }
    // 🟡 còn lại
    // (0 <  thời gian dừng sản xuất < 30 ) hoặc lỗi chất lượng cao
    return 'yellow_state';
  };

  getColorOfDayCbm = (issueOfDay, dateNum) => {
    if (!issueOfDay) return 'emtpy_state';

    const {
      isRestDay,
      countQualityTotal = 0,
      highestQualityProductionDownTimeMinutes = 0,
      highestQualityErrorProductNumber = 0,
    } = issueOfDay;

    const thisDay = dayjs().date(dateNum).day();

    // Ngày nghỉ cuối tuần
    if (isRestDay && (thisDay === 6 || thisDay === 0)) {
      return 'emtpy_state';
    }

    let today = dayjs();
    let selectedTime = dayjs(this.props.selectedMonth);
    if (
      today.get('month') <= selectedTime.get('month') &&
      today.get('year') <= selectedTime.get('year') &&
      dateNum > today.get('date')
    ) {
      return 'emtpy_state';
    }

    // 🔴 Có thời gian dừng sản xuất > 30 hoặc lỗi chất lượng cao > 3
    if (highestQualityProductionDownTimeMinutes > 30 || highestQualityErrorProductNumber > 3) {
      return 'red_state';
    }
    //🟢 Không dừng sản xuất và không lỗi chất lượng cao
    if (highestQualityProductionDownTimeMinutes === 0 && highestQualityErrorProductNumber === 0) {
      return 'green_state';
    }
    // 🟡 còn lại
    // (0 <  thời gian dừng sản xuất < 30 ) hoặc lỗi chất lượng cao
    return 'yellow_state';
  };

  getColorOfDaySpa = (issueOfDay, dateNum) => {
    if (issueOfDay) {
      let thisDay = dayjs().date(dateNum).day();
      if (issueOfDay.isRestDay && (thisDay == 6 || thisDay == 0)) {
        return 'emtpy_state';
      }

      if (!issueOfDay.countQualityTotal || issueOfDay.countQualityTotal <= 0) {
        let today = dayjs();
        let selectedTime = dayjs(this.props.selectedMonth);
        if (
          today.get('month') <= selectedTime.get('month') &&
          today.get('year') <= selectedTime.get('year') &&
          dateNum == today.get('date')
        ) {
          return 'emtpy_state';
        }

        return 'green_state';
      }

      if (!issueOfDay.countNumberProductDestroy) {
        return 'green_state';
      }

      if (issueOfDay.countNumberProductDestroy > 0 && issueOfDay.countNumberProductDestroy <= 5) {
        return 'yellow_state';
      }

      if (issueOfDay.countNumberProductDestroy > 5) {
        return 'red_state';
      }
    }

    return 'emtpy_state';
  };

  getColorOfDay = (
    issueOfDayFac,
    issueOfDayIqc,
    issueOfDayInt,
    issueOfDayCbm,
    issueOfDayWh,
    issueOfDaySpa,
    dateNum,
  ) => {
    let thisDay = dayjs().date(dateNum).day();
    if (issueOfDayFac) {
      let today = dayjs();
      let selectedTime = dayjs(this.props.selectedMonth);
      if (
        today.get('month') <= selectedTime.get('month') &&
        today.get('year') <= selectedTime.get('year') &&
        dateNum > today.get('date')
      ) {
        return 'emtpy_state';
      }

      const colorInt = this.getColorOfDayInt(issueOfDayInt, dateNum);
      const colorCbm = this.getColorOfDayCbm(issueOfDayCbm, dateNum);
      const colorSpa = this.getColorOfDaySpa(issueOfDaySpa, dateNum);

      if (
        colorInt === 'emtpy_state' &&
        colorCbm === 'emtpy_state' &&
        colorSpa === 'emtpy_state' &&
        (thisDay == 6 || thisDay == 0)
      ) {
        return 'emtpy_state';
      }

      if (
        ![colorInt, colorCbm, colorSpa].includes('yellow_state') &&
        ![colorInt, colorCbm, colorSpa].includes('red_state')
      ) {
        return 'green_state';
      }

      if ([colorInt, colorCbm, colorSpa].includes('red_state')) {
        return 'red_state';
      }

      return 'yellow_state';
    }

    return 'emtpy_state';
  };

  populateElements = (start, end) => {
    let items = [];
    for (let i = start; i <= end; i++) {
      let issueOfDayFac = this.props?.dataInMonthFac[i - 1];
      let issueOfDayIqc = this.props?.dataInMonthIqc[i - 1];
      let issueOfDayInt = this.props?.dataInMonthInt[i - 1];
      let issueOfDayCbm = this.props?.dataInMonthCbm[i - 1];
      let issueOfDayWh = this.props?.dataInMonthWh[i - 1];
      let issueOfDaySpa = this.props?.dataInMonthSpa[i - 1];

      let color = this.getColorOfDay(
        issueOfDayFac,
        issueOfDayIqc,
        issueOfDayInt,
        issueOfDayCbm,
        issueOfDayWh,
        issueOfDaySpa,
        i,
      );
      items.push(
        <DayQualityElement
          oneTypeIssue={this.props.oneTypeIssue}
          showInfo={this.showInfo}
          num={i}
          color={color}
          issues={issueOfDayInt}
          lastClickedElement={this.props.lastClickedElement}
          lastGroupClicked={this.props.lastGroupClicked}
        />,
      );
    }
    return items;
  };

  render() {
    return (
      <>
        <div id="table-quality">{this.populateElements(1, 31)}</div>
        {this.props.factory ? (
          <></>
        ) : (
          <h3 className="center" style={{ paddingLeft: '30px', marginTop: '20px' }}>
            Quality
          </h3>
        )}
      </>
    );
  }
}

export default QualityLayout;
